import { useState } from "react";
import { fetchProblemList } from "../../utils/patients/fetchProblemList";
import { fetchClinicalTask } from "../../utils/patients/fetchClinicalTask";




const useManageClinicalTask = () => {
    const [loading, setLoading] = useState(false);
    const [task, setTask] = useState([]);
    const {profile} =  useState()


  const handleFetchClinicalTask = async () => {
    setLoading(true);
    try{
      const response = await fetchClinicalTask(profile?.id)
      
      setTask(response.data);
      console.log(response.data);
      
    } catch(err) {
      console.log(err)
      window.location.href = "/pages/signin2";
      console.log("error error");

    } finally {
      setLoading(false)
    }
  };


  return {
    handleFetchClinicalTask,
    loading,
    task
  };

}

export default useManageClinicalTask;